import EditPartForm from './EditPartForm'
export default EditPartForm;
